import React, {FunctionComponent, useState} from 'react';

import './Banner.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IBanner {
    className?:string;

    onClose?: () => void;
}

const Banner:FunctionComponent<IBanner> = (props) => {
    const [hidden, setHidden] = useState(false);

    if(hidden)
        return null;

    const handleCloseIconClick = () => {
        setHidden(true);

        if(props.onClose)
            props.onClose();
    }
    return <div className={`banner ${props.className}`}>
        {props.children}

        <button type="button" className="close banner__close-icon" onClick={handleCloseIconClick}>
            &times;
        </button>
    </div>
};

export default Banner;
